module.exports = {
          srcSet: __webpack_public_path__ + "4aaad1370e6bed58ba99b7c4b123725b-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "4aaad1370e6bed58ba99b7c4b123725b-180.png",width: 180,height: 9}],
          src: __webpack_public_path__ + "4aaad1370e6bed58ba99b7c4b123725b-180.png",
          toString:function(){return __webpack_public_path__ + "4aaad1370e6bed58ba99b7c4b123725b-180.png"},
          
          width: 180,
          height: 9
        }